import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaCalendarCheck, FaCalendarDay, FaStar } from 'react-icons/fa';
import { MdOutlineDeliveryDining, MdRestaurantMenu } from 'react-icons/md';
import { BiTimeFive } from 'react-icons/bi';

const SubscriptionPlans = () => {
  // TJP Brand Colors
  const colors = {
    primaryOrange: '#FD7E4B',
    primaryGreen: '#2e7d32',
    creamBg: '#FDF0DD'
  };

  // Plan Data
  const plans = [
    {
      id: 'trial',
      title: 'Trial Pack',
      subtitle: 'Experience Quality',
      desc: 'Test our taste and delivery service before committing.',
      icon: <FaCalendarDay size={24} />,
      color: 'secondary',
      btnVariant: 'outline-secondary',
      delay: 0
    },
    {
      id: 'weekly',
      title: 'Weekly Plan',
      subtitle: 'Build a Habit',
      desc: 'Sorted for the week. No daily ordering hassles.',
      icon: <FaCalendarCheck size={24} />,
      color: 'success', // Brand Green
      btnVariant: 'outline-success',
      delay: 0.1
    },
    {
      id: 'monthly',
      title: 'Monthly Plan',
      subtitle: 'Best Value',
      desc: 'Consistent nutrition at our lowest price per meal.',
      icon: <FaStar size={24} />,
      color: 'warning', // Brand Orange
      btnVariant: 'warning',
      isPopular: true,
      delay: 0.2
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5 }
    }),
    hover: { y: -5, boxShadow: "0px 10px 25px rgba(0,0,0,0.1)" }
  };

  return (
    <section className="py-5" style={{ backgroundColor: '#fff' }} id="plans">
      <Container>
        {/* Header */}
        <div className="text-center mb-5" data-aos="fade-up">
          <h6 className="text-uppercase fw-bold small" style={{ color: colors.primaryOrange, letterSpacing: '1px' }}>
            Flexible Options
          </h6>
          <h3 className="fw-bold text-dark">
            Choose Your Plan
          </h3>
          <p className="text-muted small">Pause or cancel anytime.</p>
        </div>

        {/* Plans Grid */}
        <Row className="g-4 justify-content-center mb-5">
          {plans.map((plan, index) => (
            <Col md={4} key={plan.id}>
              <motion.div
                custom={index}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
                variants={cardVariants}
              >
                <Card 
                  className={`h-100 border-0 shadow-sm text-center ${plan.isPopular ? 'border border-2 border-warning' : ''}`}
                  style={{ borderRadius: '20px', position: 'relative' }}
                >
                  {plan.isPopular && (
                    <Badge 
                      className="position-absolute top-0 start-50 translate-middle px-3 py-2 rounded-pill shadow-sm"
                      style={{ fontSize: '0.75rem', zIndex: 1, backgroundColor: colors.primaryOrange, color: '#fff' }}
                    >
                      Most Popular
                    </Badge>
                  )}

                  <Card.Body className="p-4 d-flex flex-column">
                    <div className={`mb-3 mx-auto p-3 rounded-circle bg-light text-${plan.color}`}>
                      {plan.icon}
                    </div>
                    
                    <h5 className="fw-bold mb-1">{plan.title}</h5>
                    <small className={`fw-bold text-${plan.color} mb-3 d-block`}>{plan.subtitle}</small>
                    
                    <p className="text-muted small mb-4 flex-grow-1">
                      {plan.desc}
                    </p>

                    <Button 
                      variant={plan.btnVariant} 
                      className={`w-100 rounded-pill fw-bold ${plan.isPopular ? 'text-dark' : ''}`}
                      size="sm"
                    >
                      Select {plan.title}
                    </Button>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>

        {/* Footer Features Banner */}
        <div style={{ backgroundColor: colors.creamBg }} className="p-3 rounded-4 mt-2">
          <Row className="text-center g-3">
            <Col xs={4} className="d-flex flex-column align-items-center justify-content-center">
              <MdRestaurantMenu size={20} style={{ color: colors.primaryGreen }} className="mb-1" />
              <small className="fw-bold text-muted" style={{ fontSize: '0.75rem' }}>Standard Weekly Menu</small>
            </Col>
            <Col xs={4} className="d-flex flex-column align-items-center justify-content-center border-start border-end">
              <MdOutlineDeliveryDining size={20} style={{ color: colors.primaryGreen }} className="mb-1" />
              <small className="fw-bold text-muted" style={{ fontSize: '0.75rem' }}>Free Delivery</small>
            </Col>
            <Col xs={4} className="d-flex flex-column align-items-center justify-content-center">
              <BiTimeFive size={20} style={{ color: colors.primaryGreen }} className="mb-1" />
              <small className="fw-bold text-muted" style={{ fontSize: '0.75rem' }}>Freshly Prepared</small>
            </Col>
          </Row>
        </div>

      </Container>
    </section>
  );
};

export default SubscriptionPlans;